import { Component } from '@angular/core';
import { LoadingService } from './loading.service';

@Component({
  selector: 'app-nbp-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})

export class LoadingComponent {
  constructor(public loadingService: LoadingService) {}

}



// WEBPACK FOOTER //
// ./src/app/shared-layout/loading/loading.component.ts